import { hasKey, isDefined, jsGetAge, isStringEmpty } from "../../shared/utils";
import { iniReader } from "../../fileoprators/iniReaderWriter";
import fileSys from "../../fileoprators/fileSystem";
import { FILES, INVALID_1000, MAPSTYLES } from "../shared";
import { calcElevDiff } from "./calc4mmElevDiff";
import moment from "moment";
import DataParams from "../dataGetters/params";
import { normalMapValues } from "../dataGetters/mapValues";
import { MAP_K_DATA } from "../../shared/consts";
import CalCaseDebug from "./CalCaseDebug";

const xml2js = window.require("xml2js");
const xmlBuilder = new xml2js.Builder();
var calib = null;

const addonDT = window.__ct__.debug
  ? CalCaseDebug
  : window.require(fileSys.getUtilPath("DEA520Data.node"));
function getFullName(patient) {
  if (isDefined(patient)) {
    if (isDefined(patient.lastname) && !isStringEmpty(patient.lastname)) {
      return `${patient.firstname}_${patient.lastname}`;
    } else {
      return patient.firstname;
    }
  }
  return "";
}

function getAge(birthday) {
  if (birthday) {
    return jsGetAge(birthday);
  } else {
    return "";
  }
}

function getCalib() {
  if (!calib) {
    let obj = iniReader(fileSys.getCalibPath(FILES.calib)) || {};
    let centerPoint = obj.CenterPoint || {};
    let camCalib = obj.CenterCamCalib || {};
    let roi = obj.Roi || {};

    calib = {
      $: {
        version: "1"
      },
      ID: "",
      CalibrationDate: "",
      Comments: "",
      CenterCamera: {
        Size_Width: 2048,
        Size_Height: 1536,
        CenterPoint: {
          x: centerPoint.x || "",
          y: centerPoint.y || "",
          r: centerPoint.r || "",
          r1: centerPoint.r1 || "",
          r2: centerPoint.r2 || ""
        },
        PixelSize: {
          meibomian: camCalib.meibomian || "",
          tearheight: camCalib.tearheight || "",
          nibut: camCalib.nibut || "",
          pupilcornea: camCalib.pupilcornea || "",
          topo_near: camCalib.toponear || "",
          topo_far: camCalib.topofar || ""
        },
        FocusRoi: {
          r: roi.r || "",
          focuslimit: roi.focusLimit || ""
        }
      }
    };
  }

  return calib;
}
function getQS(dataParams) {
  let obj = dataParams.QS || {};
  return {
    OffsetX: obj.OffsetX || "",
    OffsetY: obj.OffsetY || "",
    OffsetZ: obj.OffsetZ || "",
    AreaU: obj.AreaU || "",
    AreaD: obj.AreaD || "",
    AreaA: obj.AreaA || "",
    TearN: obj.TearN || "",
    TearA: obj.TearA || ""
  };
}
// 2mm~9mm
function get8mmVal(str, index = 6) {
  if (!isDefined(str)) {
    return INVALID_1000;
  }
  let arr = str._trim("[")._trim("]").split(",");
  if (!Array.isArray(arr) || arr.length < index) {
    return INVALID_1000;
  }

  let n = parseFloat(arr[index]);
  return isNaN(n) ? INVALID_1000 : n;
}
function getAvgEcc(stra, strb) {
  if (stra && strb) {
    let a = get8mmVal(stra);
    let b = get8mmVal(strb);
    if (a !== INVALID_1000 && b !== INVALID_1000) {
      // ecc值需要在pVal值的基础上进行处理
      a = Math.sqrt(a > 1 ? 1 - 1 / a : 1 - a);
      b = Math.sqrt(b > 1 ? 1 - 1 / b : 1 - b);
      return ((a + b) / 2)._toFixed(2);
    }
  }
  return INVALID_1000;
}
function getAvgK(stra, strb) {
  if (stra && strb) {
    let a = get8mmVal(stra);
    let b = get8mmVal(strb);
    if (a !== INVALID_1000 && b !== INVALID_1000 && a !== 0 && b !== 0) {
      // ecc值需要在pVal值的基础上进行处理
      a = MAP_K_DATA / a;
      b = MAP_K_DATA / b;
      return ((a + b) / 2)._toFixed(2);
    }
  }
  return INVALID_1000;
}
function calcK_e_At8mm(dataparams) {
  let obj = {
    Horizontal_e_8mm: INVALID_1000,
    Vertical_e_8mm: INVALID_1000,
    HorizontalK_8mm: INVALID_1000,
    VerticalK_8mm: INVALID_1000
  };
  if (!dataparams) {
    return obj;
  }

  if (dataparams.FrontpValOfMajMeridians) {
    obj.Horizontal_e_8mm = getAvgEcc(
      dataparams.FrontpValOfMajMeridians.Nas,
      dataparams.FrontpValOfMajMeridians.Temp
    );
    obj.Vertical_e_8mm = getAvgEcc(
      dataparams.FrontpValOfMajMeridians.Inf,
      dataparams.FrontpValOfMajMeridians.Sup
    );
  }

  if (dataparams.FrontSagCurvOfMajMeridians) {
    obj.HorizontalK_8mm = getAvgK(
      dataparams.FrontSagCurvOfMajMeridians.Nas,
      dataparams.FrontSagCurvOfMajMeridians.Temp
    );
    obj.VerticalK_8mm = getAvgK(
      dataparams.FrontSagCurvOfMajMeridians.Inf,
      dataparams.FrontSagCurvOfMajMeridians.Sup
    );
  }

  return obj;
}
function getCorneaFront(casePath, dataParams) {
  let flat, steep;
  if (dataParams && dataParams.CorneaFront) {
    flat = parseInt(dataParams.CorneaFront.AxisFlat);
    steep = parseInt(dataParams.CorneaFront.AxisSteep);
  }
  let heightDiff8 = calcElevDiff(casePath, flat, steep).val;
  if (heightDiff8 !== INVALID_1000) {
    heightDiff8 = heightDiff8._toFixed(0);
  }
  let obj = dataParams.CorneaFront || {};
  let objMerdian = calcK_e_At8mm(dataParams);

  return {
    K: {
      K1: obj.K1 || "",
      K2: obj.K2 || "",
      KMax: obj.Kmax || "",
      Astig: obj.Astig || "",
      AxisFlat: obj.AxisFlat || "",
      AxisSteep: obj.AxisSteep || ""
    },
    SRI: obj.SRI || "",
    SAI: obj.SAI || "",
    IS: obj.IS || "",
    R: {
      Rf: obj.Rf || "",
      Rs: obj.Rs || "",
      Rm: obj.Rm || "",
      Rmin: obj.Rmin || "",
      RminX: obj.RminX || "",
      RminY: obj.RminY || ""
    },
    Heightdiff_8mm: heightDiff8,
    Horizontal_e_8mm: objMerdian.Horizontal_e_8mm || "",
    Vertical_e_8mm: objMerdian.Vertical_e_8mm || "",
    HorizontalK_8mm: objMerdian.HorizontalK_8mm || "",
    VerticalK_8mm: objMerdian.VerticalK_8mm || ""
  };
}
function getMap(mapType, caseFolder) {
  let matsize = 121;
  let len = matsize * matsize;
  let outdata = new Float64Array(len);
  outdata.fill(INVALID_1000);

  let datapath;
  if (mapType === MAPSTYLES.ElevationF) {
    datapath = fileSys.combinePath(caseFolder, FILES.cartCrnf);
  } else if (mapType === MAPSTYLES.SCurvatureF) {
    datapath = fileSys.combinePath(caseFolder, FILES.cartSagf);
  }
  let result = addonDT.ExportMatData(
    datapath,
    fileSys.combinePath(caseFolder, FILES.cartFlgf),
    outdata.buffer,
    mapType === MAPSTYLES.ElevationF ? 0 : 1,
    matsize
  );
  let mapdata = "";
  if (result) {
    mapdata += "\n";
    for (let i = 0; i < len; i++) {
      mapdata += Math.round(outdata[i] * 1000) / 1000;
      if ((i + 1) % matsize === 0) {
        mapdata += "\n";
      } else {
        mapdata += " ";
      }
    }
  }
  return {
    Cols: 121,
    Rows: 121,
    InvalidDataValue: -1000,
    WorldCoords: {
      Low: {
        X: -6,
        Y: -6
      },
      High: {
        X: 6,
        Y: 6
      }
    },
    MinimumValue: "",
    MaximumValue: "",
    Data: mapdata
  };
}
function getDia(record, eyetype) {
  let pupildia, corneadia;
  let coe = window.magecoe.pupilcornea;
  if (hasKey(record, `content.data${eyetype}.pupilcorneadia.pupildia`)) {
    let obj = record.content[`data${eyetype}`].pupilcorneadia.pupildia;
    if (isDefined(obj.edge) && isDefined(obj.edge.r)) {
      pupildia = (obj.edge.r * 2 * coe)._toFixed(2);
    }
  }
  if (hasKey(record, `content.data${eyetype}.pupilcorneadia.corneadia`)) {
    let obj = record.content[`data${eyetype}`].pupilcorneadia.corneadia;
    if (isDefined(obj.edge) && isDefined(obj.edge.r)) {
      corneadia = (obj.edge.r * 2 * coe)._toFixed(2);
    }
  }
  return { pupildia, corneadia };
}
function getCTRecord(record, caseFolder, eyetype) {
  const iniPath = fileSys.combinePath(caseFolder, FILES.acdotana);
  let dataParams = iniReader(iniPath) || {};
  let shotInfoPath = fileSys.combinePath(caseFolder, FILES.shotJson);
  let objShotInfo = fileSys.readJsonFile(shotInfoPath);
  let checktype;
  if (objShotInfo && objShotInfo.shotInfo && objShotInfo.shotInfo.shotMode) {
    checktype = `topo_${objShotInfo.shotInfo.shotMode}`;
  } else {
    checktype = record.checktype;
  }
  let objDia = getDia(record, eyetype);
  return {
    $: {
      version: "1"
    },
    DataVersion: "1",
    EyeType: eyetype === "OD" ? "Right" : eyetype === "OS" ? "Left" : "",
    TopographyCase: {
      CheckDate: moment(record.recorddate).format("MM/DD/YYYY HH:mm:ss"),
      CheckType: checktype || "",
      Data: {
        $: {
          version: "1"
        },
        QS: getQS(dataParams),
        CorneaFront: getCorneaFront(caseFolder, dataParams),
        IRImage: {
          PupilDia: objDia.pupildia || "",
          CorneaDia: objDia.corneadia || ""
        },
        Map: {
          // CorneaHeight,TangentialCurvatureFront,SagitalCurvatureeFront,TearFilmQuality
          CornealHeight: getMap(MAPSTYLES.ElevationF, caseFolder),
          // TangentialCurvatureFront: getMap(MAPSTYLES.TCurvatureF),
          SagitalCurvatureFront: getMap(MAPSTYLES.SCurvatureF, caseFolder)
          // TearFilmQuality: getMap(MAPSTYLES.TCurvatureF)
        }
      }
    }
  };
}
function getPatient(patient) {
  let sex = patient.sexdb || patient.sex || "";
  return {
    $: {
      version: "1"
    },
    ID: patient.pid || "",
    LastName: patient.lastname || "",
    FirstName: patient.firstname || "",
    Title: "",
    Gender: sex === "F" ? "Female" : sex === "M" ? "Male" : "",
    DateofBirth: patient.birthday || "",
    Age: getAge(patient.birthday),
    Tags: ""
  };
}

function combineMwf(objDevice, objCalib, objPatient, objRecords) {
  if (!objPatient || !objRecords) {
    return null;
  }
  objCalib = objCalib || getCalib();
  objDevice = objDevice || {
    $: {
      version: "1"
    },
    ID: "",
    Motor: "",
    Comments: ""
  };
  let obj = {
    Dea520ExportFile: {
      $: {
        version: "1"
      },
      Patient: objPatient,
      Device: objDevice,
      Calibration: objCalib,
      Dea520Case: objRecords
    }
  };
  return obj;
}

class ExportMwfXml {
  constructor() {
    this.objPatient = null;
    this.objRecords = null;
    this.objCalib = null;
    this.objDevice = null;
    this._patientId = null;
  }
  addCTRecord(patient, record, caseFolder, eyeType) {
    if (!this.objPatient || this._patientId !== patient._id) {
      this.objPatient = getPatient(patient);
      this.objRecords = [];
    }
    this._patientId = patient._id;
    this.objRecords = this.objRecords || [];
    this.objRecords.push(getCTRecord(record, caseFolder, eyeType));
  }
  get() {
    let obj = combineMwf(this.objDevice, this.objCalib, this.objPatient, this.objRecords);
    return obj;
  }
  save(patient, rootpath) {
    let obj = combineMwf(this.objDevice, this.objCalib, this.objPatient, this.objRecords);
    let xml = xmlBuilder.buildObject(obj).toString();
    let xmlpath = `${rootpath}/${getFullName(patient)}.mwf`;
    fileSys.mkdirSync(rootpath);
    fileSys.writeFileSync(xmlpath, xml);
  }
}
export default ExportMwfXml;



// WEBPACK FOOTER //
// ./src/topography/js/exportMwfXml.js